import { useQuery } from '@tanstack/react-query';

import { getPropertyUsers } from '@/services/api/propertyUsers';

/**
 * Hook to fetch property users with their profile information.
 * Returns property access records enriched with user names and emails.
 *
 * @param propertyId - The property ID to fetch users for
 * @returns Object containing propertyUsers array and loading state
 */
export const usePropertyUsers = (propertyId: string) => {
  const {
    data: propertyUsers,
    isLoading: isLoadingUsers,
    isFetching: isFetchingUsers,
  } = useQuery({
    queryKey: ['property-users', propertyId],
    queryFn: () => getPropertyUsers(propertyId),
    enabled: Boolean(propertyId),
  });

  return {
    propertyUsers: propertyUsers ?? [],
    isLoadingUsers: isLoadingUsers || isFetchingUsers,
  };
};
